import { TestResult } from '../types'

/* ---------------------------- 🔧 Util functions --------------------------- */

export const getPassedTestsCount = (tests: TestResult[]) => {
  return tests.reduce((acc, test) => acc + (test.passed ? 1 : 0), 0)
}
